import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function UnaffectedProstateCancer() {
    return ReferralCriteria({
        criteria: [
            (<>Unaffected individual with two first/second degree relatives with prostate cancer under 60</>),
            (<>Unaffected individual with three relatives diagnosed with prostate cancer at any age on the same side of the family</>)
        ],
        properties: {
            color: 'blue'
        }
    });
}

export default UnaffectedProstateCancer;
